'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	TITLE: "What's included",
	SLIDES: {
		MINECRAFT: [
			{
				TITLE: 'Course Library',
				CHECKLIST: [
					'Teacher-designed courses',
					'80+ hours of video content',
					'Weekly progress updates'
				],
				IMAGE: 'image-course-library',
				BACKGROUND: 'slide-background-course-library'
			},
			{
				TITLE: 'Private Server',
				CHECKLIST: ['Safe and secure for kids', '24/7 backups', 'Up to 25 players'],
				IMAGE: 'image-private-server',
				BACKGROUND: 'slide-background-private-server'
			},
			{
				TITLE: 'Code Editor',
				CHECKLIST: ['Drag-drop interface', 'Learn real Java', 'Runs in web browser'],
				IMAGE: 'image-code-editor',
				BACKGROUND: 'slide-background-code-editor'
			},
			{
				TITLE: 'Online support',
				CHECKLIST: ['Professional coding help', 'Fast, live responses', '7 days a week'],
				IMAGE: 'image-online-support',
				BACKGROUND: 'slide-background-online-support'
			}
		],
		MINECRAFT_TEST: [
			{
				TITLE: 'Course Library',
				CHECKLIST: [
					'Teacher-designed courses',
					'80+ hours of video content',
					'Weekly progress updates'
				],
				IMAGE: 'image-course-library',
				BACKGROUND: 'slide-background-course-library'
			},
			{
				TITLE: 'Code Editor',
				CHECKLIST: ['Drag-drop interface', 'Learn real Java', 'Runs in web browser'],
				IMAGE: 'image-code-editor',
				BACKGROUND: 'slide-background-code-editor'
			},
			{
				TITLE: 'Online support',
				CHECKLIST: ['Professional coding help', 'Fast, live responses', '7 days a week'],
				IMAGE: 'image-online-support',
				BACKGROUND: 'slide-background-online-support'
			},
			{
				TITLE: 'Private Server',
				CHECKLIST: ['Safe and secure for kids', '24/7 backups', 'Up to 25 players'],
				IMAGE: 'image-private-server',
				BACKGROUND: 'slide-background-private-server'
			}
		],
		ROBLOX: [
			{
				TITLE: 'Course Library',
				CHECKLIST: ['Teacher-designed courses', '20+ hours of video content', 'Progress tracking'],
				IMAGE: 'image-roblox-course-library',
				BACKGROUND: 'slide-background-course-library'
			},
			{
				TITLE: 'Code Editor',
				CHECKLIST: ['Drag-drop interface', 'Learn real Lua code', 'Runs in web browser'],
				IMAGE: 'image-roblox-code-editor',
				BACKGROUND: 'slide-background-code-editor'
			},
			{
				TITLE: 'Publish Games',
				CHECKLIST: ['Play with friends', 'Share your creations', 'Test in Roblox Studio'],
				IMAGE: 'image-roblox-publish-games',
				BACKGROUND: 'slide-background-private-server'
			},
			{
				TITLE: 'Online support',
				CHECKLIST: ['Professional coding help', 'Fast, live responses', '7 days a week'],
				IMAGE: 'image-roblox-online-support',
				BACKGROUND: 'slide-background-online-support'
			}
		],
		GENERIC: [
			{
				TITLE: 'Course Library',
				TEXT:
					'Learn to code with our teacher designed courses, updated every month. Keep track of your progress with weekly updates.',
				IMAGE: 'image-course-library',
				BACKGROUND: 'slide-background-course-library'
			},
			{
				TITLE: 'Code Editor',
				TEXT:
					'Start simple with our beginner-friendly drag-and-drop editor, then progress to text code. Learn real programming languages.',
				IMAGE: 'image-code-editor',
				BACKGROUND: 'slide-background-code-editor'
			},
			{
				TITLE: 'Online support',
				TEXT:
					'Get help when you need it 7 days a week. Fast, live responses from the Code Kingdoms team.',
				IMAGE: 'image-online-support',
				BACKGROUND: 'slide-background-online-support'
			}
		],
		EDUCATORS: [
			{
				TITLE: 'Premium Learning Resources',
				CHECKLIST: [
					'Lesson plans designed by our team of teachers to support you. Exclusively available to instructors of our partner camps.'
				],
				IMAGE: 'carousel-resources',
				BACKGROUND: 'slide-background-camp-dashboard'
			},
			{
				TITLE: 'Flexible Credits',
				CHECKLIST: [
					'Our day credits can be used across all our products. You have the freedom to allocate credit based on your platform usage, not to a fixed number of seats.'
				],
				IMAGE: 'carousel-credits',
				BACKGROUND: 'slide-background-camp-costs'
			},
			{
				TITLE: 'Free Instructor Accounts',
				CHECKLIST: [
					"We don't charge for instructor accounts. Prepare for camp without time limits or restrictions."
				],
				IMAGE: 'carousel-instructor',
				BACKGROUND: 'slide-background-camp-promotion'
			},
			{
				TITLE: 'Instructor dashboard',
				CHECKLIST: [
					'Easy-to-use admin tools so your time is focused on running great sessions with your students.'
				],
				IMAGE: 'carousel-dashboard',
				BACKGROUND: 'slide-background-course-library'
			},
			{
				TITLE: 'Curriculum & Technical Support',
				CHECKLIST: [
					'A dedicated account manager will be on hand to guide you through everything from technical issues to curriculum design.'
				],
				IMAGE: 'carousel-account',
				BACKGROUND: 'slide-background-code-editor'
			},
			{
				TITLE: 'Affiliate Program & Marketing Support ',
				CHECKLIST: [
					'When students purchase memberships after camp, we pay you a commission. Access our library of marketing assets to promote your camp.'
				],
				IMAGE: 'carousel-marketing',
				BACKGROUND: 'slide-background-private-server'
			}
		],
		SCHOOLS: [
			{
				TITLE: 'Premium Learning Resources',
				CHECKLIST: [
					'Lesson plans designed by our team of teachers to support you. Exclusively available to instructors.'
				],
				IMAGE: 'carousel-resources',
				BACKGROUND: 'slide-background-camp-dashboard'
			},
			{
				TITLE: 'Flexible Credits',
				CHECKLIST: [
					'Our day credits can be used across all our products. You have the freedom to allocate credit based on your platform usage, not to a fixed number of seats.'
				],
				IMAGE: 'carousel-credits',
				BACKGROUND: 'slide-background-camp-costs'
			},
			{
				TITLE: 'Free Instructor Accounts',
				CHECKLIST: [
					"We don't charge for instructor accounts. Prepare for classes without time limits or restrictions."
				],
				IMAGE: 'carousel-instructor',
				BACKGROUND: 'slide-background-camp-promotion'
			},
			{
				TITLE: 'Instructor dashboard',
				CHECKLIST: [
					'Easy-to-use admin tools so your time is focused on running great lessons with your students.'
				],
				IMAGE: 'carousel-dashboard',
				BACKGROUND: 'slide-background-course-library'
			},
			{
				TITLE: 'Curriculum & Technical Support',
				CHECKLIST: [
					'A dedicated account manager will be on hand to guide you through everything from technical issues to curriculum design.'
				],
				IMAGE: 'carousel-account',
				BACKGROUND: 'slide-background-code-editor'
			}
		]
	}
});
